import React from "react";
import { Skeleton } from "antd";

const CustomSkeleton = ({
  skeletonCount = 2,
  skeletonHeight = "1rem",
  skeletonWidth = "20rem",
  skeletonMarginBottom = "5px",
  fullSize = false,
  // "node" (default) keeps the original Skeleton.Node behavior unchanged.
  // "button" renders a full-width Skeleton.Button that reliably fills width
  // and honors an explicit height — useful for content-area placeholders.
  variant = "node",
  block = true,
}) => {
  return (
    <>
      {[...Array(skeletonCount)].map((_, index) =>
        variant === "button" ? (
          <Skeleton.Button
            key={index}
            active
            block={block}
            style={{
              width: skeletonWidth,
              height: skeletonHeight,
              marginBottom: skeletonMarginBottom,
            }}
          />
        ) : (
          <Skeleton.Node
            key={index}
            style={{
              width: skeletonWidth,
              height: skeletonHeight,
              marginBottom: skeletonMarginBottom,
            }}
            active
            fullSize={fullSize}
          />
        )
      )}
    </>
  );
};

export default CustomSkeleton;
